import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
	DefaultMatterAdjustmentHeat,
	MatterAdjustmentHeat,
} from '@models/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { cloneDeep } from 'lodash';
import { AdjustmentData } from '../adjustments.types';
import { calculateHeat } from '../../../../shared/services/adjustments';
import { ICON } from '@core/util/icon';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { AdjustmentsDispatch } from '@state/matter/adjustments';
import { SelectedMatter } from '@state/matter/matter.selectors';

@Component({
	selector: 'app-heat-dialog',
	templateUrl: './heat-dialog.component.html',
	standalone: false,
})
export class HeatDialogComponent implements OnInit {
	adjustment: MatterAdjustmentHeat;
	creditAmount: number;
	@ViewSelectSnapshot(AdjustmentsSelector.heatAdjustment)
	heatAdjustmentFilterFn: (id: string) => MatterAdjustmentHeat;
	@SelectSnapshot(SelectedMatter.matterHST) hst: number;
	hstAmount: number;
	readonly ICON = ICON;
	taxAmount: number;
	totalUnitCost: number;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AdjustmentData,
		private dialogRef: MatDialogRef<HeatDialogComponent>,
		private adjustmentDispatch: AdjustmentsDispatch,
	) {}

	ngOnInit(): void {
		this.adjustment = cloneDeep(
			this.heatAdjustmentFilterFn(this.data.adjustmentId),
		);
		this.creditAmount = 0;
		this.changed();
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	changed(): void {
		if (
			this.adjustment.heatType !== 'propane' &&
			this.adjustment.heatType !== 'oil'
		) {
			this.adjustment = {
				...DefaultMatterAdjustmentHeat,
				heatType: this.adjustment.heatType,
				id: this.adjustment.id,
				order: this.adjustment.order,
			};
		}

		const calc = calculateHeat(
			this.adjustment.heatType,
			this.adjustment.capacity,
			this.adjustment.cost,
			this.adjustment.applyCarbonTax,
			this.adjustment.taxCost,
			this.adjustment.applyHst,
			this.hst,
		);

		this.creditAmount = calc.creditAmount;
		this.hstAmount = calc.hstAmount;
		this.taxAmount = calc.taxAmount;
		this.totalUnitCost = calc.totalUnitCost;
	}

	saveModal(): void {
		this.adjustmentDispatch.Set(this.adjustment);
		this.dialogRef.close();
	}
}
